import { compose, withProps } from 'recompose'
import Article from './Article'
import { withBlocks } from 'pages/blocks'

export default compose(
  withBlocks('getPost'),
  withProps(({ page }) => {
    const {
      content: { rendered: content },
      articleData: { executiveSummary, pdf, sources, contactCard, link },
    } = page.wpPage

    return {
      content,
      executiveSummary,
      contactCard,
      pdf,
      sources,
      link,
    }
  }),
)(Article)
